export enum XpoFacetFilterEFieldModel {
  ClientSide,
  ServerSide,
}
